module.exports = __webpack_public_path__ + "img/ANTOJITOS.ef829484.png";